import { render, staticRenderFns } from "./_RecoveryDetails.vue?vue&type=template&id=7b92869e&"
import script from "./_RecoveryDetails.vue?vue&type=script&lang=ts&"
export * from "./_RecoveryDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./_locales/RecoveryDetails.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2FdeceasedDonors%2F_RecoveryDetails.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports